import { httpV2 } from "@/api";

/**
 * @summary Solicita todos os limites personalizados e notificações de limites configurados de uma empresa.
 * @param companyId - Id da empresa.
 * @returns Array contendo os limites personalizados e notificações de limites configurados para cada turbina.
 */
const GetTrendLimitsConfiguration = function(companyId = 0)
{
	return httpV2.get(`/HydroCompaniesTrendLimitsConfigurations/${companyId}/LimitsNotifications`);
};

/**
 * @summary Solicita os parâmetros de configuração em lote para limites de sinais e configurações.
 * @param companyId - Id da empresa.
 * @returns Array contendo todas as turbinas de uma empresa e os sinais em comum.
 */
const GetTrendLimitsParameters = function(companyId = 0)
{
	return httpV2.get(`/HydroCompaniesTrendLimitsConfigurations/${companyId}/SettingsParams`);
};

/**
 * @summary Cria limites personalizados para tendências e notificações em lote.
 * @param companyTrendLimitModel - Modelo contendo a configuração em lote.
 * @returns Mensagem de sucesso.
 */
const CreateCompanyTrendLimitNotification = function(companyTrendLimitModel)
{
	return httpV2.post("/HydroCompaniesTrendLimitsConfigurations/", companyTrendLimitModel);
};

/**
 * @summary Apaga limites personalizados para tendências e notificações em lote.
 * @param companyTrendLimitDeleteModel - Modelo contendo a configuração que será apagada.
 * @returns Mensagem de sucesso.
 */
const DeleteCompanyTrendLimitNotification = function(companyTrendLimitDeleteModel)
{
	return httpV2.delete("/HydroCompaniesTrendLimitsConfigurations/", { data: companyTrendLimitDeleteModel });
};

export default {
	GetTrendLimitsConfiguration,
	GetTrendLimitsParameters,
	CreateCompanyTrendLimitNotification,
	DeleteCompanyTrendLimitNotification
};